<template>
    <el-dialog
            :title="titleText"
            width="25%"
            :visible="true"
            :before-close="handleClose">
        <el-form ref="form">
            <el-form-item label="组名称" :label-width="formLabelWidth">
                <el-input type="text" v-model="form.name"></el-input>
            </el-form-item>

            <!--<el-form-item label="所属产品" :label-width="formLabelWidth">-->
                <!--<el-select v-if="services.length > 0"-->
                           <!--v-model="form.service" style="width:100%"-->
                           <!--:disabled="disableService"-->
                           <!--placeholder="请选择所属产品">-->
                    <!--<el-option-->
                            <!--v-for="item in services"-->
                            <!--:key="item.service_key"-->
                            <!--:label="item.service_name"-->
                            <!--:value="item.service_key"-->
                    <!--&gt;-->
                    <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose()">取 消</el-button>
            <el-button type="primary" @click="submitForm()">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import AccountService from "~/services/CustomerAccounts"

    export default {
        data() {
            return {
                services: [],
                formLabelWidth: '80px',
                isShow: false,
                newGroupName: '',
                newId: '',
                newService: '',
                form: {},
                disableService: false,
                titleText: "添加用户组",
            }
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            group: {
                type: Object,
                default: null
            }
        },

        created: function () {
            this.getServices();
            if (this.group == null) {
                this.form = this.getGroupModel();
            } else {
                this.form = {
                    id: this.group.id,
                    name: this.group.name,
                    service: this.group.service,
                    customer_id: this.group.customer_id
                };
            }

            // 修改组的时候不让改所属产品服务
            if (this.form.id > 0) {
                this.disableService = true;
                this.titleText = "修改用户组";
            }



        },

        methods: {

            getGroupModel() {
                return {
                    id: 0,
                    customer_id: this.customerId,
                    name: '',
                    // 20190426
                    service: 'xwt',
                };
            },

            handleClose() {
                this.close();
            },

            close() {
                this.$emit("createGroupCallback", this.isShow);
                this.$refs['form'].resetFields();
            },

            // 提交新增用户组数据
            submitForm() {
                if (this.form.id > 0) {
                    AccountService.updateGroup(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: "新增成功",
                                type: "success"
                            });
                            this.close();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error"
                            });
                        }
                    });
                } else {
                    AccountService.createGroup(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: "新增成功",
                                type: "success"
                            });
                            this.close();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error"
                            });
                        }
                    });
                }

            },

            getServices() {
                AccountService.getServices().then(res => {
                    if (res.code == 0) {
                        this.services = res.data;
                    }
                }).catch(error => {
                    console.error(error);
                })
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/customer/dialog/addGroupDialog.vue